import React from 'react'
import Header from '../../componets/Header'
import Footer from '../../componets/Footer'
import ContactUs from './ContactUs'
function AboutUs() {
    return (
        <>
            <Header />
            <div>
                <section id="jumbotron">
                    <div className="content">
                        <div className='object-main-content'>
                            <h2 className='object-about-title'>About Urban Data Analytics Center</h2>
                            <p className='object-about-text'>Rate of urbanisation in Madhya Pradesh is fast reaching the National average of 28%. It is
                                expected to cross the 30% mark in another 15 years. Most of the increase in urban population
                                in the state is driven by increase in number of habitations entering the urban strata rather than
                                increase in population of existing urban area.</p>
                        </div>
                    </div>
                </section>
                {/* <section id="body">
                <div class="content">
                    <h2>A Top Curve</h2>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut etiam sit amet nisl.</p>
                </div>
            </section> */}
                <div className='object-content object-container'>
                    <div className='row justify-content-center'>
                        <div className='col-xl-8 col-lg-8 col-md-10'>
                            <p className='administrationtext'>Urban Administration & Development Department, Madhya Pradesh continuously provide the multiple services to citizens i.e., Water tanker, birth/death certificate, marriage certificate, property & water tax collection, Garbage collection, Trading and hoarding license etc.</p>
                            <h6 className='departmenttitle'>Department enhance the citizen experience and easy in departmental operation through
                                IT & GIS Technologies.
                                <br />
                                The objective of this initiative is –</h6>
                            <div className='row justify-content-center object-card' style={{ rowGap: "24px" }}>
                                <div className='col-lg-3 col-md-4 col-sm-6 col-12'>
                                    <div className='about-card'>
                                        <img src="img/analytics.svg" alt='analysis' />
                                        <h6 className='object-title'>Effective departmental Planning</h6>
                                    </div>
                                </div>
                                <div className='col-lg-3 col-md-4 col-sm-6 col-12'>
                                    <div className='about-card'>
                                        <img src="img/support.svg" alt='Decisition' />
                                        <h6 className='object-title'>Act as Decision support system</h6>
                                    </div>
                                </div>
                                <div className='col-lg-3 col-md-4 col-sm-6 col-12'>
                                    <div className='about-card'>
                                        <img src="img/data-report.svg" alt='mis' />
                                        <h6 className='object-title'>Insights of data, analysis & visualisation</h6>
                                    </div>
                                </div>
                                <div className='col-lg-3 col-md-4 col-sm-6 col-12'>
                                    <div className='about-card'>
                                        <img src="img/responsible.svg" alt='services' />
                                        <h6 className='object-title'>Efficient delivery of citizen services</h6>
                                    </div>
                                </div>
                                <div className='col-lg-3 col-md-4 col-sm-6 col-12'>
                                    <div className='about-card'>
                                        <img src="img/growth.svg" alt='services' />
                                        <h6 className='object-title'>Cost recovery and revenue generation</h6>
                                    </div>
                                </div>
                                <div className='col-lg-3 col-md-4 col-sm-6 col-12'>
                                    <div className='about-card'>
                                        <img src="img/magnifying-glass.svg" alt='services' />
                                        <h6 className='object-title'>Improved transparency of ULB</h6>
                                    </div>
                                </div>
                                <div className='col-lg-3 col-md-4 col-sm-6 col-12'>
                                    <div className='about-card'>
                                        <img src="img/layersservices.svg" alt='services' />
                                        <h6 className='object-title'>Clean and more efficient urban services</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ContactUs />
            <Footer />
        </>
    )
}

export default AboutUs
